import { Controller } from "@hotwired/stimulus"

// Connects to data-controller="validate-radio-fields"
export default class extends Controller {
  static targets = [ 'wrapper', 'help', 'radio' ]
  static values = { force: Boolean }

  connect() {
    if (this.forceValue == true) {
      this.resetRadioButtons()
    } else {
      this.clear()
    }
  }

  validate() {
    this.clear()
  }

  resetRadioButtons() {
    this.radioTargets.forEach( (elem) => { elem.checked = false } )
  }

  clear() {
    this.wrapperTarget.classList.remove('is-warning')
    this.wrapperTarget.classList.remove('notification')
    this.wrapperTarget.classList.add('mb-2')
    this.helpTarget.classList.add('is-hidden')
  }
}
